// extracted by mini-css-extract-plugin
export default {"StepWrapper":"Step_StepWrapper__g5OQu","StepWrapper__title":"Step_StepWrapper__title__STEVn"};